import { Link } from 'react-router-dom'

export function BakeryHomeView() {
  return (
    <div className="page page--bakery-home">
      <div className="bakery-home-awning" aria-hidden />
      <header className="bakery-home-header">
        <h1 className="bakery-home-title">
          <span className="bakery-home-title-emoji" aria-hidden>🧁</span>
          Bakery
        </h1>
        <Link to="/" className="bakery-home-back" aria-label="Back to store selection">←</Link>
      </header>

      <section className="bakery-home-section" aria-labelledby="bakery-choose-heading">
        <h2 id="bakery-choose-heading" className="bakery-home-section-title">What do you want to do?</h2>
        <div className="bakery-home-cards">
          <Link
            to="/bakery/bake"
            className="bakery-home-card bakery-home-card--bake"
            aria-label="Bake something with ingredients"
          >
            <span className="bakery-home-card-emoji" aria-hidden>👩‍🍳</span>
            <span className="bakery-home-card-name">Bake</span>
            <span className="bakery-home-card-desc">Pick a recipe, add ingredients, and watch it come together!</span>
          </Link>
          <Link
            to="/bakery/shop"
            className="bakery-home-card bakery-home-card--shop"
            aria-label="Shop for bakery treats"
          >
            <span className="bakery-home-card-emoji" aria-hidden>🛒</span>
            <span className="bakery-home-card-name">Shop</span>
            <span className="bakery-home-card-desc">Buy cookies, cupcakes & more for your cart.</span>
          </Link>
        </div>
      </section>

      <footer className="bakery-home-footer">
        <Link to="/parent" className="home-parent-link">Parent</Link>
      </footer>
    </div>
  )
}
